module.exports = __webpack_public_path__ + "img/email.a5cf31a3.svg";